import {ManagerFiltersControls, ManagerFilterType} from '../../home/manager-filters/manager-filters.component';
import {differenceInDays, format, subDays} from 'date-fns';

const actualDate: Date = new Date();
const defaultDatePattern = 'YYYY-MM-DD';

export function getActualDate(): string {
    return format(actualDate, defaultDatePattern);
}

export function subtractDaysFrom(date: Date, numberOfDays: number): string {
    return format(subDays(date, numberOfDays), defaultDatePattern);
}

export function getDifferenceInDays(endDate: any, beginDate: any): number {
    return differenceInDays(endDate, beginDate);
}

export function getManagerFilterBeginDate(filtersControls: ManagerFiltersControls): string {
    switch (filtersControls.type) {
        case ManagerFilterType.Today:
            return getActualDate();
        case ManagerFilterType.FifteenDays:
            return subtractDaysFrom(actualDate, 15);
        case ManagerFilterType.ThirtyDays:
            return subtractDaysFrom(actualDate, 30);
        case ManagerFilterType.Range:
            return format(filtersControls.begin, defaultDatePattern);
        default:
            return '';
    }
}

export function getManagerFilterEndDate(filtersControls: ManagerFiltersControls): string {

    if (filtersControls.type === ManagerFilterType.Range) {
        return format(filtersControls.end, defaultDatePattern);
    }

    return getActualDate();
}
